module.exports = __webpack_public_path__ + "img/45-logo-mobile-new.d7095aa0.png";